import React from 'react';

import ReportTemplate from 'src/components/ReportTemplate';

const Report = props => {
  return <ReportTemplate {...props} />;
};

export default Report;
